import { GET } from '../request'

export const getCodigosPromocionales = () =>
  GET('/api/agora/datos/codigo-promocional/list/active')

export const getCodigosPromocionalesHabilitados = () =>
  GET('/api/agora/datos/codigo-promocional/list/enabled')
